jQuery(document).ready(function($) {
    // Prevent default hash behavior after form submission
    $(document).on('gform_confirmation_loaded', function(event, form_id) {
        // Find the form container dynamically using form ID
        var formContainer = $('#gform_wrapper_' + form_id);

        if (formContainer.length) {
            // Scroll to the form's wrapper smoothly
            $('html, body').animate({
                scrollTop: formContainer.offset().top
            }, 500);  // Adjust speed if necessary
        }

        // Remove hash from URL if it exists
        if (window.location.hash) {
            history.replaceState(null, null, window.location.href.split('#')[0]);
        }
    });
});